import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostCreatePaymentTermTemplateMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { usePageState } from "../../../../Hook/usePageState";
const CreateForm = () => {
  const navigate = useNavigate();
  // const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [CreatePaymentTermsTemplate] = usePostCreatePaymentTermTemplateMutation();

  // tab1
  // const [TemplateName, setTemplateName] = useState("");
  // const [AllocatePaymentBasedOnPaymentTerms, setAllocatePaymentBasedOnPaymentTerms] = useState("");
  // const [selected_payment_term_data, setselected_payment_term_data] = useState([]);

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   TemplateName: false,
  });

  
const pageStateDefault = {
    tab: 1,
    TemplateName:'',
    AllocatePaymentBasedOnPaymentTerms:false,
    selected_payment_term_data: [{ payment_term: "",
    description: "",
    due_date_based_on: "",
    invoice_portion: "",
    credit_days: "" }],
  };

  const [pageState, setPageState] = usePageState(`Create Payment Term Template`, pageStateDefault);


  const { tab,TemplateName,AllocatePaymentBasedOnPaymentTerms,selected_payment_term_data } = pageState;

  const handleSubmit = async () => {

 

    setFieldErrors({
      TemplateName: false,
    });

    let hasError = false;
    const newErrors = {
      TemplateName: !TemplateName,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!TemplateName) {
      setptype("Error");
      setError("Please Fill Template Name.");
      setShowError(true);
      return;
    }
   

  const payload = {
  template_name: TemplateName,
  allocate_payment_based_on_payment_terms: AllocatePaymentBasedOnPaymentTerms,
  terms: selected_payment_term_data
};


  console.log("create payment terms template payload:", payload);
    try {
      const response = await CreatePaymentTermsTemplate(payload); // RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Creation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Payment Terms template created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/payment-term-template/payment-term-template-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayoutTwo
      title="New Payment Terms Template"
      breadcrumbs={[
         { label: "Payment Terms Template"},
        { label: "Payment Terms Template List", url: "/master/payment-term-template/payment-term-template-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    setPageState({ ...pageState, tab: 1 })
                  }}
                  href="#"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
             <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
            </div>
          </div>
        </div>
 <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
               <Tab1
                       TemplateName={{
                      value: pageState.TemplateName,
                      setValue: (val) => setPageState({ ...pageState, TemplateName: val }),
                      error: fieldErrors.TemplateName,
                    }}
                   AllocatePaymentBasedOnPaymentTerms={{
                      value: pageState.AllocatePaymentBasedOnPaymentTerms,
                      setValue: (val) => setPageState({ ...pageState, AllocatePaymentBasedOnPaymentTerms: val }),
                      error: fieldErrors.AllocatePaymentBasedOnPaymentTerms,
                    }}
  
                   pageState={pageState}
								  setPageState={setPageState}

                   selected_payment_term_data={{
  value: pageState.selected_payment_term_data || [],
  setValue: (val) => setPageState({
    ...pageState,
    selected_payment_term_data: val,
  }),
}}
                    
                  />
              </div>
            </div>
          </div>
        </div>
       
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default CreateForm;
